
const translations = {
    DDL_ACTIVE_PASS_TYPES: {
        description: 'Active Pass Types',
        primaryValue: 'Active Pass Types',
        stringKey: 'DDL_ACTIVE_PASS_TYPES',
    },
    DDL_ALL_AVAILABLE_HISTORY: {
        description: 'All Available History',
        primaryValue: 'All Available History',
        stringKey: 'DDL_ALL_AVAILABLE_HISTORY',
    },
    PASS_TYPE_ALL_TYPES: {
        description: 'All Type',
        primaryValue: 'All Type',
        stringKey: 'PASS_TYPE_ALL_TYPES',
    },
    PASS_TYPE_COMP: {
        description: 'Comp Pass Type',
        primaryValue: 'Comp',
        stringKey: 'PASS_TYPE_COMP',
    },
    PASS_TYPE_VENDOR: {
        description: 'Vendor',
        primaryValue: 'Vendor',
        stringKey: 'PASS_TYPE_VENDOR',
    },
    PASS_TYPE_GUEST: {
        description: 'Guest',
        primaryValue: 'Guest',
        stringKey: 'PASS_TYPE_GUEST',
    },
    PASS_TYPE_VIP: {
        description: 'VIP',
        primaryValue: 'VIP',
        stringKey: 'PASS_TYPE_VIP',
    },
    EMPLOYEE_ACTIVE_PAGE_NAME: {
        description: 'Visitor Passes Grid',
        primaryValue: 'Visitor Passes',
        stringKey: 'EMPLOYEE_ACTIVE_PAGE_NAME',
    }
}

export default translations;